import TytMatematik from "../pages/matematik/tyt/TytMatematik";


export const MatematikTyt = [
  {
    path: "/matematik/tyt",
    element: <TytMatematik activeDivProps={1} />
  }
];

